/**
 * Receives a segment URL, and opens a `HEAD` request on the segment in order
 * to determine if the segment is available.
 *
 * If the request succeeds, `true` is returned, otherwise `false` for any incurred
 * error or failure response.
 */

const getHasSegmentSucceeded = async (lastSegmentUrl: string): Promise<boolean> => {
    let response: Response;

    try {
        response = await fetch(lastSegmentUrl, {
            method: 'HEAD'
        });
    } catch (err) {
        return false;
    }

    return response.ok;
};

export default getHasSegmentSucceeded;